import React from 'react';
export function Disclaimer() {
  return <section aria-labelledby="disclaimer-title" className="mx-auto w-full max-w-4xl px-4 pb-16 sm:px-6 lg:px-8" data-id="element-80" data-mp="236v1yg8osqwh">
      <div className="border-t border-stone-200 pt-8" data-id="element-81" data-mp="3crhb090y6cxv">
        <h2 id="disclaimer-title" className="text-sm font-semibold text-stone-900" data-id="element-82" data-mp="2xx2xup42dxr4">
          Informazioni sul materiale
        </h2>
        <p className="mt-3 text-xs leading-relaxed text-stone-500 md:text-sm" data-id="element-83" data-mp="32vmnazhv9ro8">
          Materiale educativo sul sistema tradizionale Bach. Non sostituisce diagnosi, psicoterapia o cure mediche. Le
          associazioni tradizionali descritte non costituiscono prova di efficacia clinica.
        </p>
      </div>
    </section>;
}